import styled from 'styled-components';
import { TagListField } from 'ci-common-ui';

export const StyledTagListField = styled(TagListField).attrs({
  width: 380,
  minWidth: 350
})``;
